import React, { useEffect, useState } from "react";
// @ts-ignore
import { useParams } from 'react-router-dom'
import { useLocalStorage } from "../utils/use-local-storage";
import JsonView from 'react-json-view';
import { requestJSON } from "../utils/request-module";
import SolidityWizardHeader from "src/components/solidity-wizard-header";
import CustomProgressBar from "src/components/custom-progress-bar";
import { makeStyles } from "@material-ui/core";
import CustomTabs from "src/components/custom-tabs";
import TabPanel from "src/components/tab-panel";
import { CodeEditor } from "src/components/code-editor";
import FileExplorer from "src/components/file-explorer";
import createTaskList from "src/create-task-list";
import { FullScreenOff, FullScreenOn } from "src/components/icons-svg";
import TaskList from "src/components/taskList";
import AuditProcess from "src/components/audit-process";
var auditProcess = require('../../../shared/audit-process')
// @ts-ignore
import { getLibraryURL } from "../utils/get-simulation-library-url";
import { synchronizeIcon, successIcon, closeIcon } from "../components/icons-svg";
import store from "src/store";
import useHistory from "../use-history";

const useStyles = makeStyles({
  flex_container: {
    display: 'flex'
  },
  child: {
    flex: '1',
    padding: '5px',
    borderRadius: '10px',
    border: '1px solid',
    margin: '5px',
    backgroundColor: '#fff',
    overflow: 'hidden'
  },
});

export default function SolidityWizard() {
  const classes = useStyles();

  const { id } = useParams();

  const [leftPanelFocusMode, setLeftPanelFocusMode] = useLocalStorage('leftPanelFocusModeOn', false);
  const [rightPanelFocusMode, setRightPanelFocusMode] = useLocalStorage('rightPanelFocusModeOn', false);
  const [showAST, setShowAST] = useLocalStorage('showAST', false);
  const [showSourceMap, setShowSourceMap] = useLocalStorage('showSourceMap', false);
  const history = useHistory();

  const ALL_RIGHT_TABS = [
    {
      label: 'Original',
      disabled: false,
    },
    {
      label: 'Simplified',
      disabled: false,
    },
    {
      label: 'Plain English',
      disabled: false,
    },
    {
      label: 'Original AST',
      disabled: false,
    },
    {
      label: 'Simplified AST',
      disabled: false,
    },
  ];

  const [tabs, setTabs] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectedFilePath, setSelectedFilePath] = useState("");
  const [selectedFileCode, setSelectedFileCode] = useState("");
  const [completedTasks, setCompletedTasks] = useState({});
  const [simplifiedData, setSimplifiedData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [taskObj, setTaskObj] = useState({});
  const [reviewData, setReviewData] = useState(null);
  const [saveMessage, setSaveMessage] = useState(null);
  const [cursorPositionInOriginal, setCursorPositionInOriginal] = useState({
    column: 1,
    lineNumber: 1
  });
  const [cursorPositionInSimplified, setCursorPositionInSimplified] = useState({
    column: 1,
    lineNumber: 1
  });

  let numberOfTasks = !_.isEmpty(taskObj) ? taskObj['tasks'].length : 0;
  let completedTaskLength = !_.isEmpty(completedTasks) ? Object.keys(completedTasks).length : 0;

  useEffect(() => {
    checkAndSetRightTabs();
  }, [showAST]);

  const checkAndSetRightTabs = () => {
    let TAB_ITEMS = [];

    if (showAST) {
      TAB_ITEMS = ALL_RIGHT_TABS;
    } else {
      TAB_ITEMS = ALL_RIGHT_TABS.filter((item) => (!item.label.toLowerCase().includes("ast")));

      if (activeTab == 2 || activeTab == 3) {
        setActiveTab(0);
      }
    }

    setTabs(TAB_ITEMS);
  }

  const setOriginalFileData = (data) => {
    let modifiedFiles = data.files.map((item) => {
      return {
        content: item.content,
        path: item.name
      }
    });

    let thisFile = modifiedFiles[0];

    setSelectedFilePath(thisFile.path);
    setSelectedFileCode(thisFile.content);
    setFileList(modifiedFiles);
  }

  const onFileChange = (filePath) => {
    let thisFile = fileList.find(file => file.path == filePath);

    setSelectedFilePath(thisFile.path);
    setSelectedFileCode(thisFile.content);
  }

  const getCompletedTasksAndSimplifiedData = async () => {
    try {
      let promiseOne = await requestJSON("GET", '/review/completed-tasks/' + id);
      let promiseTwo = await requestJSON("GET", '/review/simplifier-data/' + id);
      let promiseThree = await requestJSON("GET", '/review/my-review/' + id);

      let response = await Promise.all([promiseOne, promiseTwo, promiseThree]);


      try { setCompletedTasks(response[0]) } catch (err) { console.log(err) }
      try { setSimplifiedData(response[1]); } catch (err) { console.log(err) }
      try { setOriginalFileData(response[1]); } catch (err) { console.log(err) }
      try { getTaskList(response[1]); } catch (err) { console.log(err) }
      try { setReviewData(response[2]); } catch (err) { console.log(err) }

    } catch (err) {
      console.log('Some error has occured while fetching completed tasks and simplified data ', err);
    }
  }

  const getTaskList = (simplifiedData) => {
    let reqDataObj = {
      originalAST: simplifiedData.originalAST,
      simplifyAST: simplifiedData.simplifyAST,
      simplifierContent: simplifiedData.simplifierContent,
      files: simplifiedData.files
    };
    let taskObjData = createTaskList(reqDataObj);
    setTaskObj(taskObjData);
  }

  useEffect(() => {
    getCompletedTasksAndSimplifiedData();
  }, []);

  const onUpdateCompletedTaskData = (task, value) => {
    let completedTasksList = JSON.parse(JSON.stringify(completedTasks));

    if (value) {
      completedTasksList[task] = value;
    } else {
      delete completedTasksList[task];
    }

    setCompletedTasks(completedTasksList);

    updateCompletedTask(completedTasksList);
  }

  const updateCompletedTask = async (data) => {
    setSaveMessage('saving');
    try {
      let url = '/review/update-completed-tasks';
      let body = {
        reviewId: id,
        completedTasks: data
      };

      requestJSON("POST", url, body).then(response => {
        if (response === '' || response === undefined) {
          setSaveMessage('notSaved');
        } else {
          setSaveMessage('saved');
        }
      }).catch(err => {
        setSaveMessage('notSaved');
      })

    } catch (err) {
      setSaveMessage('notSaved');
      console.log('Some error has occured while updating completed tasks new ', err);
    }
  }

  const onTabChange = (value) => {
    if (value == 0) {
      checkAndSetFileNameAndLineNumberInOriginal();
    };
    setActiveTab(value);
  }

  const getSimplifiedData = () => {
    let simplifierContent = simplifiedData['simplifierContent'];
    if (!showSourceMap) {
      simplifierContent = simplifiedData['simplifierContent'].replace(/\/\/.*/g, '');
    }
    return simplifierContent;
  }

  const checkAndSetFileNameAndLineNumberInOriginal = () => {
    let contentInSimplified = store.getContentFromSimlified(simplifiedData['simplifierContent'], cursorPositionInSimplified.lineNumber);
    // @ts-ignore
    let data = [...contentInSimplified.matchAll(/\/\/[^\(]+\((?<filename>[^:]+):(?<line>[0-9]+)\)/g)]

    if (data && data.length) {
      let filename = data[0].groups.filename;
      let line = data[0].groups.line;
      onFileChange(filename);
      setCursorPositionInOriginal({
        column: 1,
        lineNumber: Number(line)
      })
    }
  }

  const setCursorPositionInsimplifiedFromSourceMap = (src) => {
    let lineNumber = store.getLineNoFromCharacterNo(simplifiedData['simplifierContent'].replace(/\/\/.*/g, ''), src);
    setCursorPositionInSimplified({
      column: 1,
      lineNumber: Number(lineNumber)
    });
    setActiveTab(1);
  }

  return (
    <div css={`
        padding:35px;
        background:#F6F6FA;
        min-height:100vh;
      `}>
      <div>
        <SolidityWizardHeader />
      </div>

      <hr css={`
          margin-top:15px;
          border: 1px solid #EAEAF2;
          `}
      />

      <div css={
        `
        width: 100%;
        display: flex; 
        justify-content: flex-end;
        `
      }>
        {reviewData && <>
          <span
            css={`
        cursor:pointer;color:blue;
        :hover {
          text-decoration:underline;
        }
        `}
            onClick={() => history.push(getLibraryURL({
              engagement_id: reviewData?.['engagement_id'],
              review_id: reviewData?.['_id'],
            }))}>
            Go to simulations
          </span>
          &nbsp;
          |
          &nbsp;
          <span
            css={`
        cursor:pointer;color:blue;
        :hover {
          text-decoration:underline;
        }
        `}
            onClick={() => history.push(
              '/simplifier/' + reviewData?.['_id'])}>
            Edit Solidity
          </span>
        </>}
      </div>
      <div css={`
          text-align: right;
      `}>
        {saveMessage === 'saving' && (
          <span
          > {synchronizeIcon} Saving...</span>
        )}
        {saveMessage === 'saved' && (
          <span
          > {successIcon} Saved!</span>
        )}
        {saveMessage === 'notSaved' && (
          <span
          > {closeIcon} Error on saving data</span>
        )}
      </div>

      <div className={classes.flex_container}>

        <div className={classes.child}
          css={rightPanelFocusMode ? `display: none` : `display: block`}
        >
          <div css={`
                    margin-top:25px;
                  `}>

            <>
              {
                !_.isEmpty(taskObj) ?
                  <>
                    <div>
                      <CustomProgressBar showPercentage={true} progress={Math.floor(completedTaskLength / numberOfTasks * 100)} />
                      <div css={`
                        display: flex;
                        justify-content: space-between;`}>
                        <div>
                          You have done {completedTaskLength} / {numberOfTasks}
                        </div>
                        <span css="margin-left: 15px;">
                          {
                            leftPanelFocusMode ?
                              <span css={`
                                color:#799fd4;
                                cursor: pointer;
                                text-decoration-line: underline;
                              `}
                                onClick={() => { setLeftPanelFocusMode(false) }}>{FullScreenOff}</span>
                              :
                              <span css={`
                                  color:#799fd4;
                                  cursor: pointer;
                                  text-decoration-line: underline;
                              `}
                                onClick={() => { setLeftPanelFocusMode(true) }}>{FullScreenOn}</span>
                          }
                        </span>
                      </div>
                    </div>
                    <TaskList
                      taskObj={taskObj}
                      completedTasks={completedTasks}
                      setCompletedTask={(taskID, newValue) => onUpdateCompletedTaskData(taskID, newValue)}
                      simplifiedData={simplifiedData['simplifierContent'].replace(/\/\/.*/g, '')}
                      setCursorPositionInsimplifiedFromSourceMap={(src) => { setCursorPositionInsimplifiedFromSourceMap(src) }}
                    />
                  </>
                  : null
              }
            </>
          </div>
        </div>

        <div css={`
              flex-direction:column;
              flex: 1;
              padding: 5px;
              border-radius: 10px;
              border: 1px solid;
              margin: 5px;
              background-color: #fff;
              overflow: hidden;
              ${leftPanelFocusMode ? 'display: none' : 'display: flex'}
          `}>
          <CustomTabs tabs={tabs} value={activeTab} onTabChange={(event, value) => onTabChange(value)} orientation="horizontal" section="small" showTabs={true}>
            <div css={`
            display: flex;
            justify-content: right;`}>
              {
                activeTab == 1 &&
                <span css="margin-left: 15px;">
                  {
                    showSourceMap ?
                      <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                        onClick={() => { setShowSourceMap(false) }}>Hide sourcemap</span>
                      :
                      <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                        onClick={() => { setShowSourceMap(true) }}>Show sourcemap</span>
                  }
                </span>
              }
              <span css="margin-left: 15px;">
                {
                  showAST ?
                    <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                      onClick={() => { setShowAST(false) }}>Hide AST</span>
                    :
                    <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                      onClick={() => { setShowAST(true) }}>Show AST</span>
                }
              </span>

              <span css="margin-left: 15px;">
                {
                  rightPanelFocusMode ?
                    <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                      onClick={() => { setRightPanelFocusMode(false) }}>{FullScreenOff}</span>
                    :
                    <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    text-decoration-line: underline;
                `}
                      onClick={() => { setRightPanelFocusMode(true) }}>{FullScreenOn}</span>
                }
              </span>
            </div>

            {
              simplifiedData ?
                <>
                  <TabPanel value={activeTab} index={0}>
                    <>
                      <CodeEditor
                        fileList={fileList}
                        setFileList={setFileList}
                        selectedFilePath={selectedFilePath}
                        onFileChange={onFileChange}
                        showExpandCollapseButton={true}
                        showFileExplorer={true}
                        readOnly={true}
                        code={selectedFileCode}
                        cursorPosition={cursorPositionInOriginal}
                      />
                    </>
                  </TabPanel>
                  <TabPanel value={activeTab} index={1}>
                    <>
                      <CodeEditor
                        showFileExplorer={false}
                        readOnly={true}
                        code={getSimplifiedData()}
                        cursorPosition={cursorPositionInSimplified}
                        saveCursorPosition={(data) => setCursorPositionInSimplified(data)}
                      />
                    </>
                  </TabPanel>

                  <TabPanel value={activeTab} index={2}>
                    <EnglishfierTab data={simplifiedData['english']} />
                  </TabPanel>

                  <TabPanel value={activeTab} index={3}>
                    <JsonView
                      src={simplifiedData['originalAST']}
                      displayDataTypes={false}
                      displayObjectSize={false}
                      quotesOnKeys={false}
                      shouldCollapse={(props) => {
                        if (props.name == 'root') return false
                        return true
                      }}
                    />
                  </TabPanel>
                  <TabPanel value={activeTab} index={4}>
                    <JsonView
                      src={simplifiedData['simplifyAST']}
                      displayDataTypes={false}
                      displayObjectSize={false}
                      quotesOnKeys={false}
                      shouldCollapse={(props) => {
                        if (props.name == 'root') return false
                        return true
                      }}
                    />
                  </TabPanel>
                </> : null
            }
          </CustomTabs>
        </div>

      </div>
    </div>
  )
}

function EnglishfierTab({ data }) {
  useEffect(() => {
    var script = document.createElement('script')
    script.src = '/englishfier-script.js'
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  })
  return <div dangerouslySetInnerHTML={{ __html: data }} />
}